
const tagDefs = {
  productBadge: 'badge',
  subscribeMessage: 'subscribe-msg',
  freeShipping: 'free-shipping',
  discountPercent: 'discount-percent-',
  subscriptionAvailable: 'subscription-available',
};

const getValueByPrefix = (tags, param) => {
  const prefix = `__${param}:`;
  const tag = tags.find(tag => tag.indexOf(prefix) === 0);

  return tag ? tag.slice(prefix.length) : tag;
};

export const getProductBadge = (tags) => {
  return getValueByPrefix(tags, tagDefs.productBadge);
};

export const getSubscribeMessage = (tags) => {
  return getValueByPrefix(tags, tagDefs.subscribeMessage);
};

export const getFreeShipping = (tags) => {
  return Boolean(getValueByPrefix(tags, tagDefs.freeShipping));
};

export const getDiscountPercent = (tags, variantId) => {
  return getValueByPrefix(tags, `${tagDefs.discountPercent}${variantId}`);
};

export const getVariantsWithSubscriptions = (tags) => {
  const str = getValueByPrefix(tags, tagDefs.subscriptionAvailable);

  return str ? new Set(str.split('|').map(Number)) : new Set();
};

export const productIsBestSeller = (productTags) => {
  return productTags.includes('best-seller');
};

export const productIsNew = (productTags) => {
  return productTags.includes('new-product');
};

export const productIsNewRoast = (productTags) => {
  return productTags.includes('new-roast');
};

export const productIsSingleOrigin = (productTags) => {
  return productTags.includes('single-origin');
};

export const productIsLimitedEdition = (productTags) => {
  return productTags.includes('limited-edition');
};
